/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class DiscoveryInvokeParams {
  'regionsToScan'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "regionsToScan",
      "baseName": "regionsToScan",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DiscoveryInvokeParams.attributeTypeMap;
  }

  public constructor() {
  }
}

